import { request } from "../utils/api";

export const listDailyLogs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    search.set(key, String(value));
  });
  const q = search.toString();
  return request(`/daily-logs${q ? `?${q}` : ""}`);
};

export const deleteDailyLog = (id) =>
  request(`/daily-logs/${id}`, { method: "DELETE" });

export const applyDailyLogMarks = (data) =>
  request("/daily-logs/marks", {
    method: "POST",
    body: JSON.stringify(data),
  });
